import React, { Component } from "react"
import PropTypes from "prop-types"
import * as Sentry from "@sentry/browser"

/**
 * ErrorBoundary is a wrapper component which catches any render error on its children and,
 * instead of unmounting the entire react app, unmounts its children and replaces it with
 * it's own "error" component (so that the user can still interact with components outside the
 * boundary's scope) Also, sends the error to sentry so that we have some level of monitoring
 * around these pretty catastrophic errors.
 */
export class ErrorBoundary extends Component {
    state = {
        hasError: false,
    }
    componentDidCatch(error) {
        // send it to sentry
        Sentry.captureException(error)
        console.error(error)
    }
    static getDerivedStateFromError(error) {
        // We are checking for this value in the error stack because of a flushSyncError deriving from Editor.
        // This flushSyncError does not actually effect anything, but it causes the error message to be displayed,
        // so let's just ignore it for now...
        if (!error.stack.includes("PureEditorContent.maybeFlushSync")) {
            return { hasError: true }
        }
    }

    render() {
        // only use ErrorBoundary in prod
        // since we need the full error stack/trace when developing locally
        return this.state.hasError && !Userdata.debug_mode ? (
            <div className="error-boundary-error centered">
                <h3>
                    {this.props.errorMessage ||
                        "You have encountered an error! Quorum's development team has been notified"}
                </h3>
            </div>
        ) : (
            this.props.children
        )
    }
}

ErrorBoundary.propTypes = {
    children: PropTypes.node,
    errorMessage: PropTypes.string,
}

export default ErrorBoundary
